import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { APIClient } from "src/app/core/api-client/contracts/api-client.service";
import { IPrefixSuffix } from "src/app/shared/models/IPrefixSuffix";

@Injectable({
    providedIn: 'root'
})
export class PrefixSuffixService {
    resource = 'prefixsuffix';
    constructor(private client: APIClient) { }
    getPrefixSuffixByFacility(facilityId: number): Observable<IPrefixSuffix> {
        return this.client.get<IPrefixSuffix>(`${this.resource}/getPrefixSuffixByFacility/${facilityId}`)
    }
    createPrefixSuffix(createPrefixSuffix: IPrefixSuffix): Observable<IPrefixSuffix> {
        return this.client.post<IPrefixSuffix>(`${this.resource}/createPrefixSuffix`, createPrefixSuffix);
    }
}